/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclroleAr } from '../../models/aclrole-ar';

export interface AddRole$Params {
      body: AclroleAr
}

export function addRole(http: HttpClient, rootUrl: string, params: AddRole$Params, context?: HttpContext): Observable<StrictHttpResponse<AclroleAr>> {
  const rb = new RequestBuilder(rootUrl, addRole.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AclroleAr>;
    })
  );
}

addRole.PATH = '/api/Role';
